import * as FaIcons from 'react-icons/fa';
import * as SiIcons from 'react-icons/si';
import { SiJava } from 'react-icons/si';
import { FaProjectDiagram } from 'react-icons/fa';

import { SiNextdotjs } from 'react-icons/si';

const data = [
  {
    text: 'React',
    Icon: FaIcons.FaReact,
    doc: 'https://pt-br.reactjs.org/docs/getting-started.html',
  },
  {
    text: 'Next.js',
    Icon: SiNextdotjs,
    doc: 'https://pt-br.reactjs.org/docs/getting-started.html',
  },
  {
    text: 'TypeScript',
    Icon: SiIcons.SiTypescript,
    doc: 'https://www.typescriptlang.org/',
  },
  {
    text: 'JavaScript',
    Icon: SiIcons.SiJavascript,
    doc: 'https://developer.mozilla.org/pt-BR/docs/Learn/JavaScript/First_steps/What_is_JavaScript',
  },

  {
    text: 'CSS3',
    Icon: FaIcons.FaCss3Alt,
    doc: 'https://developer.mozilla.org/pt-BR/docs/Web/CSS',
  },
  {
    text: 'HTML5',
    Icon: FaIcons.FaHtml5,
    doc: 'https://developer.mozilla.org/en-US/docs/Glossary/HTML5',
  },
  {
    text: 'Git',
    Icon: FaIcons.FaGitAlt,
    doc: 'https://git-scm.com/docs/git/pt_BR',
  },
  {
    text: 'GitHub',
    Icon: FaIcons.FaGithub,
    doc: 'https://docs.github.com/en/get-started',
  },
  
  {
    text: 'Node.js',
    Icon: FaIcons.FaNodeJs,
    doc: 'https://nodejs.org/en/docs/',
  },
  {
    text: 'RTL',
    Icon: SiIcons.SiTestinglibrary,
    doc: 'https://testing-library.com/docs/react-testing-library/intro/',
  },
  {
    text: 'Java',
    Icon: SiIcons.SiJava,
    doc: 'https://docs.oracle.com/javase/8/docs/',
  },  
  {
    text: 'UML',
    Icon: FaProjectDiagram,
    doc: 'https://uml-diagrams.org/',
  },
  {
    text: 'POO',
    Icon: SiJava,
    doc: 'https://www.oracle.com/java/technologies/learning-path.html',
  },

];

export default data;
